import React, { useEffect, useState } from 'react';
import close_btn from '../../assets/close.svg';
import '../../css/shillaDetail.css';
import checkImg from '../../assets/check.png';
import shareImg from '../../assets/share.png';
import aboutIcon from '../../assets/aboutIcon.png';
import toggleIcon from '../../assets/toggleIcon.png';
import nftAboutIcon from '../../assets/nftAboutMenu.png';
import cardImg from '../../assets/hyatt_vip_card.png';
import lotteData from '../../assets/membership_json/lotte.json';
import tsData from '../../assets/membership_json/ts.json';
import mammothData from '../../assets/membership_json/mammoth.json';
import hyattData from '../../assets/membership_json/hyatt.json';
import vluvData from '../../assets/membership_json/vluv.json';
import { useRecoilValue } from 'recoil';
import { translatedText } from '../../recoil-states/language-state';
import emailIcon from '../../assets/icons/NYCS-bull-trans-E.png';
import ProgressiveImage from 'react-progressive-graceful-image';
import Lottie from 'react-lottie-player';
import { userConnected } from '../../recoil-states/user-state/user-state';
import { OAuthData } from '../../recoil-states/user-state/user-OAuth';
import { motion } from 'framer-motion';

const MemberShipWalletModal = ({
	setOpenDetailModal,
	openDetailModal,
	index,
	item,
	imgUrl,
}) => {
	const [openAbout, setOpenAbout] = useState(true);
	const [openDes, setOpenDes] = useState(true);
	const [tierData, setTierData] = useState(null);
	const [textDes, setTextDes] = useState(null);
	const textData = useRecoilValue(translatedText);
	const [buttonText1, setButtonText1] = useState(null);
	const [buttonText2, setButtonText2] = useState(null);
	const [packageData, setPackageData] = useState(null);
	const userData = useRecoilValue(OAuthData);
	useEffect(() => {
		document.body.style.overflow = 'hidden';

		switch (item.data.product_index.product_name) {
			case 'Konnect LOTTE VIP MEMBERSHIP':
				setTierData(textData.tier.lotte);
				setPackageData(lotteData);
				setTextDes(textData.pakageCard.lotte);
				setButtonText1(textData.modalButton['details']);
				setButtonText2(textData.modalButton['booking']);
				break;
			case 'Konnect VLUV VIP MEMBERSHIP':
				setTierData(textData.tier.vluv);
				setPackageData(vluvData);
				setTextDes(textData.pakageCard.vluv);
				setButtonText1(textData.modalButton['details']);
				setButtonText2(textData.modalButton['status']);
				break;
			case 'Konnect MAMMOTH VIP MEMBERSHIP':
				setTierData(textData.tier.mommoth);
				setPackageData(mammothData);
				setTextDes(textData.pakageCard.mammoth);
				setButtonText1(textData.modalButton['details']);
				setButtonText2(textData.modalButton['voucher']);
				break;
			case 'Konnect PARK HYATT VIP MEMBERSHIP':
				setTierData(textData.tier.hyatt);
				setPackageData(hyattData);
				setTextDes(textData.pakageCard.hyatt);
				setButtonText1(textData.modalButton['details']);
				setButtonText2(textData.modalButton['booking']);
				break;
			case 'Konnect TS VIP MEMBERSHIP':
				setTierData(textData.tier.ts);
				setPackageData(tsData);
				setTextDes(textData.pakageCard.ts);
				setButtonText1(textData.modalButton['signup']);
				setButtonText2(textData.modalButton['shopping']);
		}
		return () => {
			document.body.style.overflow = 'unset';
		};
	}, []);
	const tier1Content = ['연 1회 5만포인트 적립'];

	const tier2Content = ['온라인몰 멤버십 최대 할인적용'];

	const comming = () => {
		alert(textData.header.closed);
	};

	const onCloseModal = e => {
		if (e.target.id === 'membership_wallet_modal') {
			setOpenDetailModal(-1);
		}
	};

	const FirstButtonActionMap = {
		TS: () => {
			window.open(
				`https://www.tstrillion.com/bbs/register.php?partner_id=TS&konnect_id=${userData?.index}`
			);
		},
		LOTTE: () => {
			alert(textData.header.closed);
		},
		MAMMOTH: () => {
			alert(textData.header.closed);
		},
		'PARK HYATT': () => {
			alert(textData.header.closed);
		},
		VLUV: () => {
			alert(textData.header.closed);
		},
		default: () => {
			alert(textData.header.closed);
		},
	};

	const SecondButtonActionMap = {
		TS: () => {
			window.open(`https://www.tstrillion.com/bbs/login.php`);
		},
		LOTTE: () => {
			window.open(
				`https://www.lottehotel.com/global/ko/hotel-offers/etc/domestic-sales/KONNECT-PLATINUM_BLACK.html`
			);
		},
		MAMMOTH: () => {
			alert(textData.header.closed);
		},
		'PARK HYATT': () => {
			alert(textData.header.closed);
		},
		VLUV: () => {
			alert(textData.header.closed);
		},
		default: () => {
			alert(textData.header.closed);
		},
	};

	const onFirstButtonAction = brand => {
		/**
		 * item.data.product_index.brand 넘어오는 값
		 * TS
		 * MAMMOTH
		 * PARK HYATT
		 * VLUV
		 * LOTTE
		 */
		if (!brand) FirstButtonActionMap['default']();
		FirstButtonActionMap[brand]();
	};

	const onSecondButtonAction = brand => {
		/**
		 * item.data.product_index.brand 넘어오는 값
		 * TS
		 * MAMMOTH
		 * PARK HYATT
		 * VLUV
		 * LOTTE
		 */
		if (!brand) SecondButtonActionMap['default']();
		SecondButtonActionMap[brand]();
	};

	return (
		<div
			className='shilla_detail'
			id='membership_wallet_modal'
			onClick={onCloseModal}>
			<motion.div
				className='shilla_detail_container'
				initial={{
					opacity: 0,
					scale: 0.75,
				}}
				animate={{
					opacity: 1,
					scale: 1,
					transition: {
						ease: 'easeOut',
						duration: 0.15,
					},
				}}
				exit={{
					opacity: 0,
					scale: 0.75,
					transition: {
						ease: 'easeIn',
						duration: 0.15,
					},
				}}>
				<div className='nft_box_container'>
					<div
						className='close_btn_svg'
						style={{ cursor: 'pointer' }}>
						<img
							src={close_btn}
							style={{ zIndex: 999 }}
							onClick={() => {
								setOpenDetailModal(-1);
							}}
						/>
					</div>
					<div className='hyatt_card_img'>
						<div className='hyatt_card_background'>
							<ProgressiveImage
								src={imgUrl}
								delay={3}
								height='100%'
								width='100%'>
								{(src, loading) => {
									return !loading ? (
										<img
											src={src}
											style={{ width: '100%' }}
										/>
									) : (
										<div className='membership_skeleton'>
										</div>
									);
								}}
							</ProgressiveImage>
						</div>
					</div>
					<div className='konnect_text'>
						<h3 style={{ color: '#20CA6A' }}>
							Konnect World
							<img src={checkImg} />
							{item.data?.email_address ? (
								<img src={emailIcon} />
							) : null}
						</h3>
						<p>
							Owned by{' '}
							<span style={{ color: '#20CA6A' }}>Konnect</span>
							<img src={shareImg} />
						</p>
					</div>
					<div className='nft_detail_text_box'>
						<div className='text_box_left'>
							<h1>Konnect</h1>
							<h1>{item.data.product_index.product_name}</h1>
						</div>
						<div className='text_box_right'>
							<p>#{item.data.nft_no}</p>
						</div>
					</div>
					<div className='nft_about_box'>
						<div
							className='nft_about_top'
							style={{ borderRadius: !openAbout ? '10px' : null }}
							onClick={() => setOpenAbout(!openAbout)}>
							<div className='nft_about_box_left'>
								<img src={aboutIcon} />
								<h1>
									{packageData != null
										? packageData[0].sub_text
										: ''}
								</h1>
							</div>
							<div className='nft_about_box_right'>
								<img
									src={toggleIcon}
									style={{
										transform: openAbout
											? 'rotate(0deg)'
											: 'rotate(180deg)',
									}}
								/>
							</div>
						</div>
						<div
							className='nft_about_content'
							aria-expanded={!openAbout}>
							<p>{textDes}</p>
						</div>
					</div>
					<div className='nft_about_box'>
						<div
							className='nft_about_top'
							style={{ borderRadius: !openDes ? '10px' : null }}
							onClick={() => setOpenDes(!openDes)}>
							<div className='nft_about_box_left'>
								<img src={nftAboutIcon} />
								<h1>Description</h1>
							</div>
							<div className='nft_about_box_right'>
								<img
									src={toggleIcon}
									style={{
										transform: openDes
											? 'rotate(0deg)'
											: 'rotate(180deg)',
									}}
								/>
							</div>
						</div>
						<div
							className='nft_about_content_bottom'
							aria-expanded={!openDes}>
							<p>KONNECT Utility NFT</p>
							<h1>Benefit Information</h1>
							<div className='shilla_tier'>
								<div className='tier_one_top'>
									<h1>Tier1</h1>
								</div>
								<ul>
									{tierData != null &&
										tierData.tier1.map(it => {
											return <li key={it}>◆ {it}</li>;
										})}
								</ul>
								<div className='shlla_tier_two'>
									<div className='tier_two_top'>
										<h1>Tier2</h1>
									</div>
									<ul>
										{tierData != null &&
											tierData.tier2.map(it => {
												return (
													<li
														style={{
															color: '#BBBBBB',
														}}
														key={it}>
														◆ {it}
													</li>
												);
											})}
									</ul>
								</div>
							</div>
						</div>
					</div>
					<div className='detail_modal_btn_container'>
						{item?.data?.product_index.product_name ===
							'Konnect TS VIP MEMBERSHIP' ? (
							<div className='detail_modal_btn_top'>
								<button
									className='clasic_button_full'
									onClick={comming}>
									{textData.modalButton['details']}
								</button>
							</div>
						) : null}
						<div className='detail_modal_btn_bottom'>
							<button
								className={
									item?.data?.product_index.product_name ===
										'Konnect TS VIP MEMBERSHIP'
										? 'activity_button'
										: 'clasic_button'
								}
								onClick={() => {
									onFirstButtonAction(
										item.data.product_index.brand
									);
								}}>
								{buttonText1}
							</button>
							<button
								className='activity_button'
								onClick={() => {
									onSecondButtonAction(
										item.data.product_index.brand
									);
								}}>
								{buttonText2}
							</button>
						</div>
					</div>
				</div>
			</motion.div>
		</div>
	);
};

export default MemberShipWalletModal;
